export default function orgFeatureStateGuard(statePrefix, _orgFeature, beforePaywall) {
  const orgFeature = _orgFeature || statePrefix;
  return orgFeatureStateGuardFactory;

  function orgFeatureStateGuardFactory(
    Authentication,
    AccountService,
    $transitions,
    $injector,
    $q
  ) {
    'ngInject';

    async function noAccessAction(toState, toParams) {
      if (beforePaywall) {
        await $q.when($injector.invoke(beforePaywall));
      }

      AccountService.openPricingModal({ state: toState, params: toParams });
    }

    $transitions.onBefore({ to: `${statePrefix}.**` }, (transition) => {
      if (!Authentication.user) {
        return;
      }

      const { isAllowedToManageSubscription } = Authentication.user;
      const isFeatureActive = Authentication.isOrgFeatureEnabled(orgFeature);
      const { subscriptionOptionsEnabled } = Authentication.user.orgSettings;

      const toState = transition.$to().name;
      const toParams = transition.targetState().params();

      if (
        toState.startsWith(statePrefix) &&
        isAllowedToManageSubscription &&
        subscriptionOptionsEnabled &&
        !isFeatureActive
      ) {
        noAccessAction(toState, toParams);
        return false;
      }

      return true;
    });
  }
}
